import { AppStorage } from "~/src/contexts/StorageContext/StorageProvider";
import { IndividData } from "../schemas/schema";

type HandleOfflineIndividProps = {
  mode: "create" | "update";
  formData: IndividData;
  storage: AppStorage;
};

export const handleOfflineIndividCreateOrUpdate = ({
  mode,
  storage,
  formData,
}: HandleOfflineIndividProps) => {
  // if create individ is in queue, update existing entry and keep operation as create
  const storedIndivid = storage.get<IndividData>({ id: formData.Id }, "Individ");
  const operation =
    storedIndivid && storedIndivid.operation != "none" ? storedIndivid.operation : mode;
  storage.add({
    objectType: "Individ",
    objectKey: { id: formData.Id },
    data: formData,
    isPending: true,
    operation: operation,
    lastUpdated: new Date(),
  });
};
